<a *ngIf="!isLogin" class="nav-link">{{text | translate}}</a>
<a *ngIf="isLogin" class="nav-link" [matMenuTriggerFor]="loginMenu">{{text | translate}}</a>
    <mat-menu #loginMenu="matMenu" class="login-menu">
        <div style="padding-bottom: 50px; padding-left: 22px; padding-top: 10px;" (keydown.tab)="$event.stopPropagation()" (click)="$event.stopPropagation()">
            <form [formGroup]="form">
                <label>{{"home.login.customerNumber" | translate }}
                    <input class="form-control" formControlName="customerNumber" type="text" id="customerNumber" (keydown.enter)="submit()"
                    [ngClass]="{error: form.get('customerNumber').errors && (form.get('customerNumber').touched || (form.get('customerNumber').dirty))}" />
                </label>

                <label>{{"home.login.username" | translate }}
                    <input class="form-control" formControlName="username" type="text" id="username" (keydown.enter)="submit()"
                    [ngClass]="{error: form.get('username').errors && (form.get('username').touched || (form.get('username').dirty))}" />
                </label>

                <label>{{"home.login.password" | translate }}
                    <input class="form-control" formControlName="password" type="password" id="password" (keydown.enter)="submit()"
                    [ngClass]="{error: form.get('password').errors && (form.get('password').touched || (form.get('password').dirty))}" />
                </label>
            </form>

            <div class="d-flex" style="margin-top: 10px;">
                <label>{{"home.login.rememberMe" | translate}}</label>
                <mat-checkbox class="checkbox" [(ngModel)]="rememberMe" style="margin-top: 1%; margin-left: 50px;"></mat-checkbox>
            </div>

            <div class="validation-error" *ngIf="showError">
                <label>{{"home.login.invalidPassword" | translate}}</label>
            </div>

            <div class="d-flex"  style="margin-top: 10px;">
                <button mat-flat-button color="primary" (click)="submit()" style="width: 210px">{{'home.login.submit' | translate}}</button>
            </div>

            <div class="register-forgot-password" style="margin-top: 10px;">
                <button mat-flat-button (click)="passwordRecovery()">{{'home.login.passwordRecovery' | translate}}</button>
            </div>

            <div class="delimeter"></div>

            <div style="margin-top: 20px;">
                <button mat-flat-button color="white" (click)="register()" style="width: 210px">{{'home.login.register' | translate}}</button>
            </div>
        </div>
</mat-menu>
